/* eslint-disable @typescript-eslint/no-extraneous-class */
import { Directive, TemplateRef, inject } from '@angular/core';
import { ModalStateService } from '../../services';

/**
 * Directive allowing to get a reference to the template containing the modal component,
 * and to store it into the internal modal state service. Somewhere in the view, there must be
 *
 * ```
 * <ng-template modal>
 *   <app-modal-component></app-modal-component>
 * </ng-template>
 * ```
 *
 * in order to register the modal template to the internal modal state
 */
@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: 'ng-template[modal]',
})
export class ModalTemplateDirective {
  constructor() {
    const modalTemplate = inject<TemplateRef<any>>(TemplateRef);
    const state = inject(ModalStateService);

    state.template = modalTemplate;
  }
}
